module.exports = __webpack_public_path__ + "img/logomem.a1efcb0e.jpg";